/* IMPORT */
/* MAIN */
const METHODS = ['COPY', 'DELETE', 'GET', 'HEAD', 'LOCK', 'MKCOL', 'MOVE', 'OPTIONS', 'PATCH', 'POST', 'PROPFIND', 'PROPPATCH', 'PUT', 'SEARCH', 'UNLOCK'];
/* EXPORT */
export { METHODS };
